<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-button :to="{name: 'app-list', params: {serviceCode: $route.params.serviceCode}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
        实例数据
        <a href="#" class="hidden" ref="download" />
      </div>
      <b-form>
        <b-form-group label="服务名" label-for="service_code">
          <b-form-select
              id="service_code" v-model="data.service_code"
              :options="services" :disabled="true">
          </b-form-select>
        </b-form-group>
        <b-form-group label="实例代号" label-for="code">
          <b-form-input readonly id="code" type="text" v-model="data.code" />
        </b-form-group>
        <b-form-group label="产品名" label-for="product_code">
          <b-form-select id="product_code"  v-model="data.product_code" :options="products" :disabled="true" />
        </b-form-group>
        <b-form-group label="接口信息">
          <AppTab v-if="Object.keys(data.interfaces).length > 0" :items="data.interfaces" @execute="execInterface($event)" @tab-change="clearData" />
          <span v-else>暂无配置接口，<router-link :to="{ name: 'template-edit' }">点击</router-link>前往配置</span>
        </b-form-group>
      </b-form>
    </b-card>
    <b-card title="数据图表" v-if="result.chartOption.dataset.source.length">
      <echart :options="result.chartOption" style="width:100%" />
    </b-card>
    <b-card title="数据查询结果" v-if="result.items">
      <template v-if="result.fields.length">
        <b-table responsive="sm" :items="result.items" :fields="result.fields" :current-page="result.currentPage" />
        <nav>
          <b-pagination
            :total-rows="result.totalRows"
            :per-page="result.perPage"
            v-model="result.currentPage"
            @change="changePage"
            first-text="<<"
            last-text=">>"
            prev-text="<"
            next-text=">"
          />
        </nav>
      </template>
      <b-form-textarea v-else readonly v-model="result.items" no-resize max-rows="1000" />
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import utils from '@/utils/utils'
import ConfNode from '@/components/Confnode'
import AppTab from '@/views/template/AppTab'

export default {
  name: 'app-data',
  mixins: [Error],
  components: {
    ConfNode,
    AppTab
  },
  data: () => {
    return {
      data: {
        service_code: '',
        product_code: '',
        code: '',
        interfaces: '',
        descs: '',
        confs: ''
      },
      products: {},
      services: {},
      serviceTemplate: {},
      result: {
        url: '',
        query: {},
        items: null,
        fields: {},
        perPage: 10,
        currentPage: 1,
        totalRows: 0,
        dataTag: '',
        chartOption: {
          tooltip: {},
          legend: {},
          xAxis: {type: 'category'},
          yAxis: {},
          series: [],
          dataset: {
            dimensions: [],
            source: []
          }
        },
        signCheck: false
      }
    }
  },
  created () {
    this.$ajax.jsonp = (url) => {
      if (!url) {
        console.error('请传入一个url参数')
        return
      }
      return new Promise((resolve, reject) => {
        window.jsonCallBack = (result) => {
          resolve(result)
        }
        let JSONP = document.createElement('script')
        JSONP.type = 'text/javascript'
        JSONP.src = `${url}` + (url[url.length - 1] === '?' ? `callback=jsonCallBack` : `&callback=jsonCallBack`)
        document.getElementsByTagName('head')[0].appendChild(JSONP)
        setTimeout(() => {
          document.getElementsByTagName('head')[0].removeChild(JSONP)
        }, 500)
      })
    }
    this.$ajax.all([
      this.$ajax.get(api.getProductList()),
      this.$ajax.get(api.getServiceList())
    ]).then(([productdata, serviceData]) => {
      this.products = {
        null: {text: '请选择', disabled: true}
      }
      productdata.products.forEach((product) => {
        this.products[product.code] = product.name
      })
      this.services = {}
      serviceData.services.forEach((service) => {
        this.services[service.code] = service.name
      })
    })
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.$ajax.all([this.$ajax.get(api.getAppDetail(
        this.$route.params.serviceCode, this.$route.params.appCode,
        this.$route.query.productCode
      ))]).then(([appData]) => {
        this.data = appData.app_info
        this.getServiceTemplate()
      }, (res) => {
        this.handleError(res)
      })
    },
    execInterface (data) {
      this.result.url = data.address
      this.result.query = data.param
      this.result.signCheck = data.sign_check
      this.clearData()
      if (data.return_type === 'CHART') {
        this.fetchChart(data)
      } else if (data.return_type === 'FILE') {
        this.downloadResult()
      } else {
        this.result.fields = []
        for (let idx in data.table_conf) {
          if (data.table_conf[idx].field) {
            let tmp = {}
            tmp[data.table_conf[idx].field] = data.table_conf[idx].name
            this.result.fields.push(tmp)
          }
        }
        this.result.dataTag = data.data_tag
        this.fetchResult()
      }
    },
    downloadResult () {
      this.$ajax.post(api.getServiceSign(this.$route.params.serviceCode), {
        url: this.result.url, params: utils.parseQs(this.result.query)
      }).then((res) => {
        return this.$ajax.get(this.result.url + '?' + utils.parseQs(this.result.query), {responseType: 'blob', headers: res.data})
      }).catch((res) => {
        if (res && res.status !== 200) {
          this.$message.error('导出失败')
        } else {
          this.$refs.download.href = window.URL.createObjectURL(new Blob(
            [res.data], {type: res.headers['content-type']}
          ))
          this.$refs.download.download = 'data.zip'
          this.$refs.download.click()
        }
      })
    },
    fetchResult () {
      if (this.result.signCheck) {
        this.$ajax.post(api.getServiceSign(this.$route.params.serviceCode), {
          url: this.result.url, params: utils.parseQs(this.result.query)
        }).then((res) => {
          let url = this.result.url + (this.result.query ? '?' + utils.parseQs(this.result.query) : '')
          return this.$ajax.get(url, {headers: res.data})
        }).catch((res) => {
          this.handleFetchRes(res.data)
        })
      } else {
        this.$ajax.jsonp(this.result.url + (this.result.query ? '?' + utils.parseQs(this.result.query) : '')).then((res) => {
          this.handleFetchRes(res)
        })
      }
    },
    handleFetchRes (res) {
      if (res.success) {
        this.result.items = JSON.parse(JSON.stringify(res))
        if (this.result.dataTag) {
          let tagList = this.result.dataTag.split('.')
          for (let idx in tagList) {
            if (this.result.items.hasOwnProperty(tagList[idx])) {
              this.result.items = this.result.items[tagList[idx]]
            } else {
              this.$message.error('data tag有误')
              return
            }
          }
        }
        if (!this.result.fields.length) {
          this.result.items = JSON.stringify(this.result.items, null, '\t')
        }
        this.$message.info('执行成功，下拉查看结果')
      } else {
        this.$message.error('查询失败')
      }
    },
    fetchChart (interData) {
      this.result.chartOption.dataset.dimensions.push(interData.chart_conf.x_axis)
      interData.chart_conf.y_axis.map((y) => {
        this.result.chartOption.dataset.dimensions.push(y.field)
        this.result.chartOption.series.push({
          type: interData.chart_conf.type, name: y.name
        })
      })
      let url = this.result.url + '?' + utils.parseQs(this.result.query)
      this.$ajax.post(api.getServiceSign(this.$route.params.serviceCode), {
        url: url, params: ''
      }).then((res) => {
        return this.$ajax.get(url, {headers: res.data})
      }).catch((res) => {
        if (res.data.success) {
          this.result.chartOption.dataset.source = res.data.data
        } else {
          this.$message.error('查询失败')
        }
      })
    },
    clearData () {
      this.result.items = null
      this.result.totalRows = 0
      // reset chart
      this.result.chartOption.dataset = {
        dimensions: [], source: []
      }
      this.result.chartOption.series = []
    },
    changePage (page) {
      this.result.currentPage = page
      this.result.query.start = this.result.perPage * (page - 1)
      this.fetchResult()
    },
    getServiceTemplate () {
      this.$ajax.get(api.getTemplateByConsul(this.$route.params.serviceCode)).then((data) => {
        this.serviceTemplate = data['c_template_info']
        this.fixInterfaces()
      }, (res) => {
        this.handleError(res)
      })
    },
    fixInterfaces () {
      if (Object.keys(this.data.interfaces).length === 0) {
        this.data.interfaces = JSON.parse(JSON.stringify(this.serviceTemplate.interfaces))
      } else {
        if (Object.keys(this.serviceTemplate.interfaces).length > 0) {
          this.data.interfaces = this.fixParam(this.serviceTemplate.interfaces, this.data.interfaces)
        } else {
          this.data.interfaces = JSON.parse(JSON.stringify(this.serviceTemplate.interfaces))
        }
        this.fixAddress(this.data.interfaces)
      }
    },
    fixParam (template, appData) {
      let tmpData = {}
      for (let key in template) {
        if (appData.hasOwnProperty(key)) {
          if (template[key].hasOwnProperty('param')) {
            if (appData[key].hasOwnProperty('param')) {
              tmpData[key] = appData[key]
              tmpData[key].param.__Value__ = this.fixTemplate(template[key].param.__Value__, appData[key].param.__Value__)
            } else {
              tmpData[key] = template[key]
            }
          } else {
            tmpData[key] = this.fixParam(template[key], appData[key])
          }
        } else {
          tmpData[key] = template[key]
        }
      }
      return tmpData
    },
    fixTemplate (template, appData) {
      let tmpData = {}
      if (Object.prototype.toString.call(template) === '[object Object]') {
        for (let key in template) {
          let val = template[key].__Value__
          if (appData.hasOwnProperty(key)) {
            if (template[key].__Value__.hasOwnProperty('__value__')) {
              val.__value__ = appData[key].__Value__.__value__
            } else {
              val = this.fixTemplate(template[key].__Value__, appData[key].__Value__)
            }
          }
          tmpData[key] = {
            __Index__: template[key].__Index__,
            __Tag__: template[key].__Tag__,
            __Value__: val
          }
          if (template[key].hasOwnProperty('__Key__')) {
            tmpData[key].__Key__ = template[key].__Key__
          }
        }
      } else if (Object.prototype.toString.call(template) === '[object Array]') {
        tmpData = []
        for (let idx in template) {
          let val = template[idx].__Value__
          if (appData[idx]) {
            if (template[idx].__Value__.hasOwnProperty('__value__')) {
              val.__value__ = appData[idx].__Value__.__value__
            } else {
              val = this.fixTemplate(template[idx].__Value__, appData[idx].__Value__)
            }
          }
          tmpData.push({
            __Index__: template[idx].__Index__,
            __Tag__: template[idx].__Tag__,
            __Value__: val
          })
          if (template[idx].hasOwnProperty('__Key__')) {
            tmpData[idx].__Key__ = template[idx].__Key__
          }
        }
      }
      return tmpData
    },
    fixAddress (appData, lastUrls = '') {
      if (appData.hasOwnProperty('param')) {
        appData.address = this.data.descs.__Value__.url.__Value__.__value__ + lastUrls
      } else {
        for (let key in appData) {
          let newUrl = key === '_appCode_' ? this.data.code : key === '_productCode_' ? this.data.product_code : key
          this.fixAddress(appData[key], [lastUrls, newUrl].join('/'))
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AppData.vue?59e39290